import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';

export const ConsentDocument = ({document:d,open,onOpenChange,id}) => <Dialog open={open} onOpenChange={onOpenChange}>
  <DialogContent className="booking-consent-dialog" data-testid={`${id}-document`} data-lenis-prevent>
    <DialogHeader>
      <DialogTitle data-testid={`${id}-document-title`}>{d.title}</DialogTitle>
      <DialogDescription data-testid={`${id}-document-event`}>
        {d.event_label}: {d.event_name}<br/>{d.datetime_label}: {d.event_datetime}
      </DialogDescription>
    </DialogHeader>
    <div className="booking-consent-copy" data-testid={`${id}-document-body`}>
      {[1,2,3,4,5,6].map(n=><section key={n} data-testid={`${id}-section-${n}`}>
        <h2>{d[`heading_${n}`]}</h2><p>{d[`body_${n}`]}</p>
      </section>)}
      <p data-testid={`${id}-document-version`}>{d.version_label}: {d.version}</p>
    </div>
    <button type="button" className="booking-consent-close" data-testid={`${id}-document-close`} onClick={()=>onOpenChange(false)}>{d.close}</button>
  </DialogContent>
</Dialog>;